export default __webpack_public_path__ + "static/media/netruh.0c6af524.gif";